(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["new-offer-strip"] && !Shopify.designMode) return;
  try {
    (() => {
  const uniqueId = '{{ unique_id }}';
  const rail = document.getElementById(uniqueId + '-rail');
  const dotsWrap = document.getElementById(uniqueId + '-dots');

  if (!rail || !dotsWrap) return;

  rail.addEventListener('wheel', (e) => {
    if (Math.abs(e.deltaY) > Math.abs(e.deltaX)) {
      rail.scrollLeft += e.deltaY;
      e.preventDefault();
    }
  }, { passive: false });

  rail.addEventListener('click', (e) => {
    const pill = e.target.closest('[data-copy]');
    if (!pill) return;
    navigator.clipboard?.writeText(pill.dataset.copy);
    const originalText = pill.textContent;
    pill.textContent = 'COPIED';
    setTimeout(() => pill.textContent = originalText, 900);
  });

  let pages = 0, perPage = 1, slideW = 1, gap = 0;

  const compute = () => {
    const first = rail.firstElementChild;
    if (!first) return;
    const style = getComputedStyle(rail);
    gap = parseFloat(style.columnGap || style.gap) || 0;
    slideW = first.getBoundingClientRect().width + gap;
    perPage = Math.max(1, Math.round(rail.clientWidth / slideW));
    const total = rail.children.length;
    const newPages = Math.ceil(total / perPage);

    if (newPages !== pages) {
      pages = newPages;
      dotsWrap.innerHTML = '';
      for (let i = 0; i < pages; i++) {
        const b = document.createElement('button');
        b.className = 'offers__dot';
        b.type = 'button';
        b.setAttribute('aria-label', `Go to page ${i + 1}`);
        b.addEventListener('click', () => {
          const targetIndex = i * perPage;
          rail.scrollTo({ left: targetIndex * slideW, behavior: 'smooth' });
        });
        dotsWrap.appendChild(b);
      }
    }
    updateDot();
  };

  const updateDot = () => {
    if (!pages) return;
    const nearestIndex = Math.round(rail.scrollLeft / slideW);
    const currentPage = Math.floor(nearestIndex / perPage);
    [...dotsWrap.children].forEach((d, n) =>
      d.setAttribute('aria-current', n === currentPage));
  };

  let ticking = false;
  rail.addEventListener('scroll', () => {
    if (!ticking) {
      requestAnimationFrame(() => {
        updateDot();
        ticking = false;
      });
      ticking = true;
    }
  }, { passive: true });

  new ResizeObserver(compute).observe(rail);
  compute();
})();
  } catch(e) { console.error(e); }
})();

})();
